const STORAGE_KEY = 'creditoolsmx:attribution';
const ATTRIBUTION_KEYS = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_term',
  'utm_content',
  'gclid',
  'fbclid',
];

function sanitizeValue(value) {
  return String(value || '').trim().slice(0, 250);
}

export function captureAttribution(search = window.location.search) {
  if (typeof window === 'undefined') return {};

  const params = new URLSearchParams(search);
  const incoming = ATTRIBUTION_KEYS.reduce((result, key) => {
    const value = sanitizeValue(params.get(key));
    if (value) result[key] = value;
    return result;
  }, {});

  let existing = {};
  try {
    existing = JSON.parse(window.sessionStorage.getItem(STORAGE_KEY)) || {};
  } catch (error) {
    existing = {};
  }

  const attribution = {
    ...existing,
    ...incoming,
    landingPage: existing.landingPage || `${window.location.pathname}${window.location.search}`,
    referrer: existing.referrer || sanitizeValue(document.referrer),
    capturedAt: existing.capturedAt || new Date().toISOString(),
  };

  try {
    window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(attribution));
  } catch (error) {
    // Attribution remains available for the current call if storage is blocked.
  }

  return attribution;
}

export function getAttribution() {
  if (typeof window === 'undefined') return {};
  try {
    return JSON.parse(window.sessionStorage.getItem(STORAGE_KEY)) || captureAttribution();
  } catch (error) {
    return captureAttribution();
  }
}
